'use client';

import { ReactNode } from 'react';

import AttributeFilters from '@/widgets/AttributeFilters';

import { useCategoryAttributeFilters } from '@/hooks/filters/useCategoryAttributeFilters';

import { AttributeCategoryNavConfig } from './models';

import { ProductOfferSortBy } from '@/server/services/vendor/models';

type AttributeFiltersViewProps = {
    filters: ReturnType<typeof useCategoryAttributeFilters>;
    toolbar?: ReactNode;
    categoryNav?: AttributeCategoryNavConfig;
    sortBy?: ProductOfferSortBy;
    onSortChange?: (value: ProductOfferSortBy) => void;
    children: ReactNode;
    className?: string;
};

const AttributeFiltersView = ({ filters, toolbar, categoryNav, sortBy, onSortChange, children, className }: AttributeFiltersViewProps) => (
    <AttributeFilters
        className={className}
        toolbar={toolbar}
        categoryNav={categoryNav}
        sortBy={sortBy}
        onSortChange={onSortChange}
        brandFilter={
            filters.hasBrands
                ? {
                      brands: filters.brandOptions,
                      selectedBrands: filters.selectedBrandOptions,
                      selectedIds: filters.brandIds,
                      draftSelectedIds: filters.draftBrandIds,
                      search: filters.brandSearch,
                      isLoading: filters.isBrandsLoading,
                      onSearchChange: filters.setBrandSearch,
                      onChange: filters.setBrandSelection
                  }
                : undefined
        }
        schema={filters.schema}
        isLoading={filters.isLoading}
        selection={filters.selection}
        draftSelection={filters.draftSelection}
        activeCount={filters.activeCount}
        draftActiveCount={filters.draftActiveCount}
        hasInvalidDraftRanges={filters.hasInvalidDraftRanges}
        onSetValues={filters.setValues}
        onSetRange={filters.setRange}
        onClearAll={filters.clearAll}
        onResetDraft={filters.resetDraft}
        onApplyDraft={filters.applyDraft}>
        {children}
    </AttributeFilters>
);

export default AttributeFiltersView;
